<template>
  <div id="invoiceMgmt">
    <invoiceTable pageType="invoiceMgmt"></invoiceTable>
  </div>
</template>

<script>
import invoiceTable from '../activityCenter/eCommerceRefund/components/invoiceTable.vue'
export default {
  name: 'invoiceMgmt',
  components: {
    invoiceTable
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {
    
  }
};
</script>

